var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classBlock},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mouse"},[_c('div',{staticClass:"mouse-icon"},[_c('span',{staticClass:"mouse-wheel"})])])}]

export { render, staticRenderFns }